import { Middleware } from '../middleware'

const api = () =>
  new Middleware().method('GET').append(`/odin/rule_documentation`)

export default {
  getRulesDocumentations(filter = {}) {
    return api()
      .params({
        idCompany: filter?.idCompany,
        findBy: filter?.findBy,
        page: (filter.page ?? 1) - 1,
        size: filter?.size,
      })
      .build()
  },
  getListRulesDocumentations(idCompany, hasSiemRuleCorrelation) {

    return new Middleware()
      .append('/odin/rule_documentation/list')
      .params({
        idCompany,
        siem: hasSiemRuleCorrelation
      })
      .build()
  },
  deleteRuleDocumentation(id) {
    return api()
      .method('DELETE')
      .append(`/delete/${id}`)
      .build()
  },
  getRuleDocumentation(id) {
    return new Middleware()
      .method('GET')
      .append(`/odin/rule_documentation/get/${id}`)
      .build()
  },
  getRuleDocumentationCompanies(id) {
    return new Middleware()
      .method('GET')
      .append(`/odin/correlation_rule_definition/${id}/companies`)
      .build()
  },
  createRuleDocumentation(data) {
    return new Middleware()
      .method('POST')
      .append(`/odin/rule_documentation/add`)
      .setData(data)
      .build()
  },
  updateRuleDocumentation(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/rule_documentation/update/${id}`)
      .setData(data)
      .build()
  },
  updateRuleDocumentationCode(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/rule_documentation/${id}/code`)
      .setData(data)
      .build()
  },
  updateRuleDocumentationConclusion(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/rule_documentation/${id}/conclusion`)
      .setData(data)
      .build()
  },
  updateRuleDocumentationCompanies(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/correlation_rule_definition/${id}/companies`)
      .setData(data)
      .build()
  },
  updateRuleDocumentationSettings(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/rule_documentation/${id}/settings`)
      .setData(data)
      .build()
  },
}
